// ------------------------------------
// props 輸入需求 :
// props.data : object : { data: array }                ( {primary : main data, average : average : data} )
// props.chartName : str                                ( 表格名稱 )
// props.yAxis : object                                 ( y軸格式 )
// props.data_label : array                             ( ["x軸名稱", "y軸名稱"] )
// ------------------------------------
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts'
import React, { useEffect, useState } from 'react'
import '../../../../styles/_Chart_Hook_BasicLine.scss'
import { useTranslation } from 'react-i18next';

const StackedChart = (props) => {
    const { t } = useTranslation()
    // chart related
    const [ChartSet, setChartSet] = useState({
        chart: { type: "column" },
        series: []
    });
    // data number

    // useEffect(() => {setChartSet({chart:{ type:"column" }, series:[] })},[props]);
    useEffect(() => {
        let _data = props.data
        const highchart_data_fromat = [
            { name: t("GLOBAL.ALERT_STATE_1"), data: _data[0]?.data },
            { name: t("GLOBAL.ALERT_STATE_14"), data: _data[1]?.data },
            { name: t("GLOBAL.ALERT_STATE_217"), data: _data[2]?.data },
            { name: t("GLOBAL.ALERT_STATE_218"), data: _data[3]?.data },
            { name: t("GLOBAL.ALERT_STATE_12"), data: _data[4]?.data },
        ];
        setChartSet({
            chart: { type: 'column' },
            title: { text: t("HISTORY_RECORD.MONTHLY_REPORT") },
            xAxis: { categories: props.dateArr },
            yAxis: {
                min: 0,
                title: {
                    text: t("HISTORY_RECORD.times")
                },
                stackLabels: {
                    enabled: true,
                    style: {
                        fontWeight: 'bold',
                        color: ( // theme
                            Highcharts.defaultOptions.title.style &&
                            Highcharts.defaultOptions.title.style.color
                        ) || 'gray'
                    }
                }
            },
            exporting: { enabled: false },
            colors: ["#009DAE", '#F4A5A1', "#735B69", '#b7dde0', '#FEE19F'],
            legend: {
                align: 'right',
                x: -30,
                verticalAlign: 'top',
                y: 25,
                floating: true,
                backgroundColor:
                    Highcharts.defaultOptions.legend.backgroundColor || 'white',
                borderColor: '#CCC',
                borderWidth: 1,
                shadow: false
            },
            tooltip: {
                headerFormat: '<b>{point.x}</b><br/>',
                pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: highchart_data_fromat
        })

    }, [props.data])


    return (
        <div className='h-100'>
            <div className="col-4 fx-d-c fx-ccc h-100">
                <div>{props.chartName}</div>
                <div className="chart-box h-100">
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={ChartSet}
                        allowChartUpdate={true}
                        containerProps={{ className: "w-100 h-100 chart-frame" }}
                    />
                </div>
            </div>
        </div>
    )
}
export default StackedChart;